import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const CustomTemplatesContainer = styled(Box)`
  padding: 0 ${theme.spacing.medium}px;
`

export const SectionTitle = styled(Typography)`
  font-size: ${theme.typography.fontSize.xxLarge};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.menuItemText};
  padding-bottom: 16px;
  margin-bottom: 18px;
  border-bottom: 1px solid ${theme.colors.borderMedium};
`

export const SortRow = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${theme.spacing.medium}px;
`

export const SearchRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.small}px;
  margin-bottom: ${theme.spacing.medium}px;

  html[data-theme='light'] & .MuiOutlinedInput-root .MuiOutlinedInput-input:not(:focus),
  html[data-theme='light'] & .MuiFormControl-root {
    background: ${theme.colors.surfaceContainerBackground};
    border-color: ${theme.colors.strokeSecondary};
  }
`

export const ItemCountLabel = styled(Typography)`
  color: ${theme.colors.dropdownLabel};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.normal};
  line-height: 22px;
  white-space: nowrap;

  html[data-theme='light'] & {
    color: ${theme.colors.textCaption};
  }
`

export const ItemCountValue = styled('span')`
  color: ${theme.colors.menuItemText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.normal};
  line-height: 22px;

  html[data-theme='light'] & {
    font-weight: ${theme.typography.fontWeight.extraThick};
  }
`

export const TemplateCardsContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: ${theme.spacing.medium}px;

  @media (max-width: 1023px) {
    justify-content: center;
  }
`

export const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.xLarge}px ${theme.spacing.medium}px;
`

export const EmptyStateIconCircle = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  border: 1px dashed ${theme.colors.strokePrimary};
  margin-bottom: ${theme.spacing.medium}px;

  /* stroke-primary is near-white in light and vanishes on the page background. */
  html[data-theme='light'] & {
    border-color: ${theme.colors.textCaption};
  }

  svg {
    stroke: ${theme.colors.devicesSecondaryText};
  }
`

export const EmptyStateTitle = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.xxxLarge};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.menuItemText};
  text-align: center;
  margin-bottom: ${theme.spacing.xSmall}px;
`

export const EmptyStateDescription = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.xLarge};
  font-weight: ${theme.typography.fontWeight.normal};
  line-height: 24px;
  color: ${theme.colors.devicesSecondaryText};
  text-align: center;
  white-space: pre-line;
`


